import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  BookingEntryContextModel,
  BookingModel,
  BookingPostModel,
  PropertyModel,
} from '@app/core/models';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class PropertyService {
  constructor(
    private _router: Router,
    private _http: HttpClient,
  ) {}

  /**
   * Retrieves a property by its ID.
   * @param propertyId - The ID of the property to retrieve.
   * @returns An Observable that emits an array of properties.
   */
  get(propertyId: string): Observable<PropertyModel> {
    return this._http.get<PropertyModel>(
      `${environment.api.serverUrl}/properties/${propertyId}`,
    );
  }

  createBooking(data: BookingPostModel): Observable<BookingModel> {
    return this._http.post<BookingModel>(
      `${environment.api.serverUrl}/properties/${data.propertyId}/bookings`,
      { ...data.booking },
    );
  }

  /**
   * Returns the booking entry context for a property identified by its short
   * code or MongoDB _id.  When hasCandidate is true the caller should offer
   * the identity-verification flow instead of the manual booking form.
   */
  getBookingEntryContext(
    propertyIdOrCode: string,
  ): Observable<BookingEntryContextModel> {
    return this._http.get<BookingEntryContextModel>(
      `${environment.api.serverUrl}/properties/${propertyIdOrCode}/booking-entry-context`,
    );
  }
}
